//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 16/09/2023
// Version       : 1
// Description   : Dialog para editar tareas segun tipo de vehiculo
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Box,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
  FormControl,
  InputLabel,
  ListSubheader,
  Select,
  MenuItem,
  Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";

// Notification
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function EditarTareaTipoVehiculos({ tarea, open, onClose, onTareaGuardada }) {
  const [datosTarea, setDatosTarea] = useState(tarea);

  // ----------------------------------------------------

  const [selectedValue, setSelectedValue] = useState("");
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    // Establecer el valor inicial en selectedValue
    setSelectedValue(
      datosTarea.frecuencia ? datosTarea.frecuencia : datosTarea.frecuencia_km
    );
  }, []);

  // ----------------------------------------------------

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  // DESHABILITAR BOTON AL GUARDAR
  const [disBtn, setDisBtn] = useState(false);

  // ------------------------------------------------------

  //Funcion para guardar AL EDITAR
  const guardarEditarTarea = async (e) => {
    console.log("Estoy por guardar");
    setDisBtn(true);
    e.preventDefault();

    // Determinar si la frecuencia seleccionada corresponde a 'frecuenciaTareas' o 'frecuenciaKM'
    const frecuenciaSeleccionada =
      frecuenciaTareas.find((item) => item.id === selectedValue) || null;
    const frecuenciaKmSeleccionada =
      frecuenciaKM.find((item) => item.id_frecuencia_km === selectedValue) ||
      null;

    const frecuenciaValor = frecuenciaSeleccionada
      ? frecuenciaSeleccionada.id
      : "";
    const frecuenciaKmValor = frecuenciaKmSeleccionada
      ? frecuenciaKmSeleccionada.id_frecuencia_km
      : "";

    await fetch(UrlApi + "/tareas_tipo_vehiculos/" + datosTarea.id_tarea, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        tarea: datosTarea.tarea,
        // Guardar solo la frecuencia seleccionada
        frecuencia: frecuenciaValor ? frecuenciaValor : null,
        frecuencia_km: frecuenciaKmValor ? frecuenciaKmValor : null,
        parte_vehiculo: datosTarea.id_parte,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La tarea se editó exitosamente!");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al editar la tarea");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const almacenar = (e) => {
    setDatosTarea({
      ...datosTarea,
      [e.target.name]: e.target.value,
    });
  };

  // ------------------------------------------------------------------------

  const [frecuenciaTareas, setFrecuenciaTareas] = useState([]);

  const obtenerFrecuenciaTareas = () => {
    fetch(UrlApi + "/tareas_tipo_vehiculos/frecuencia_tareas")
      .then((data) => data.json())
      .then((data) => setFrecuenciaTareas(data));
  };

  useEffect(() => {
    obtenerFrecuenciaTareas();
  }, []);

  const [frecuenciaKM, setFrecuenciaKM] = useState([]);

  const obtenerFrecuenciaKM = () => {
    fetch(UrlApi + "/frecuencia_kilometros")
      .then((data) => data.json())
      .then((data) => setFrecuenciaKM(data));
  };

  useEffect(() => {
    obtenerFrecuenciaTareas();
    obtenerFrecuenciaKM();
  }, []);

  // ------------------------------------------------------------------------

  const [partesVehiculo, setPartesVehiculo] = useState([]);

  const obtenerPartesVehiculo = () => {
    fetch(UrlApi + "/vehiculos_partes")
      .then((data) => data.json())
      .then((data) => setPartesVehiculo(data));
  };

  useEffect(() => {
    obtenerPartesVehiculo();
  }, []);

  //*************************************************************************************************************************************/

  // Cierre de la notificación
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    setDisBtn(false);
    onTareaGuardada(); // Función para obtener valores de nuevo en el componente padre

    // Llama a la función que cierra el diálogo
    onClose();
  };

  return (
    <>
   <Box
        style={{
          borderWidth: 2,
          borderStyle: "solid",
          border: "2px solid #2B76A6",
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            mt: 0,
            mb: 2,
            display: "flex",
            justifyContent: "flex-start", // alineado a la izquierda
            alignItems: "flex-start",
          }}
        >
          <Typography
            variant="h6"
            color="white"
            sx={{
              backgroundColor: "#2B76A6",
              borderBottomRightRadius: "12px", // solo esquina inferior derecha
              padding: "8px 18px",
            }}
          >
            Editar Tarea
          </Typography>

          <Box
            sx={{
              display: "inline-block",
              backgroundColor: "#F5F5F5",
              padding: "6px",
              borderBottomRightRadius: "12px",
            }}
          >
            <Typography variant="subtitle1">{datosTarea.tipo_vehiculo}</Typography>
          </Box>
        </DialogTitle>

      <DialogContent>
        <form onSubmit={guardarEditarTarea}>
          <Grid container mt={1} mb={2} spacing={1}>
            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Frecuencia</InputLabel>
                <Select
                  name="frecuencia"
                  value={selectedValue}
                  onChange={handleChange}
                  label="Frecuencia"
                  required
                >
                  <MenuItem value="">
                    <em>Ninguna</em>
                  </MenuItem>
                  {/* Grupo 1: Frecuencia de Tareas */}
                  <ListSubheader
                    sx={{
                      bgcolor: "lightgray",
                      margin: "0",
                      padding: "2px 8px",
                    }}
                  >
                    Tiempo
                  </ListSubheader>
                  {frecuenciaTareas.map((item, index) => (
                    <MenuItem key={`tarea-${index}`} value={item.id}>
                      {item.valor}
                    </MenuItem>
                  ))}
                  {/* Grupo 2: Frecuencia por KM */}
                  <ListSubheader
                    sx={{
                      bgcolor: "lightgray",
                      margin: "0",
                      padding: "2px 8px",
                    }}
                  >
                    Distancia
                  </ListSubheader>
                  {frecuenciaKM.map((item, index) => (
                    <MenuItem key={`km-${index}`} value={item.id_frecuencia_km}>
                      {item.valor_km} km
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Parte del Vehículo</InputLabel>
                <Select
                  name="id_parte"
                  value={datosTarea.id_parte}
                  onChange={almacenar}
                  label="Parte del Vehículo"
                  required
                >
                  {partesVehiculo.map((opcion) => (
                    <MenuItem key={opcion.id_parte} value={opcion.id_parte}>
                      {opcion.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Tarea"
                name="tarea"
                size="small"
                fullWidth
                value={datosTarea.tarea}
                onChange={almacenar}
                margin="normal"
              />
            </Grid>
          </Grid>

          <Grid container direction={{ xs: "column", sm: "row" }}>
            <Grid item xs={9}>
              <Button variant="contained" color="error" onClick={onClose}>
                Volver
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                type="submit"
                disabled={disBtn}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
      </Box>

      {/* Notificación al Guardar */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default EditarTareaTipoVehiculos;
